import Colors from 'assets/Colors';
import Images from 'assets/Images';
import Lang from 'assets/Lang';
import BaseButton from 'common/components/bases/BaseButton';
import BaseText from 'common/components/bases/BaseText';
import DropAlert from 'common/components/views/DropAlert';
import AppConst from 'consts/AppConst';
import Const from 'consts/Const';
import UIConst from 'consts/UIConst';
import moment from 'moment';
import React, { Component } from 'react';
import { Image, Linking, Platform, StyleSheet, View } from 'react-native';
import AntDesign from 'react-native-vector-icons/AntDesign';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import Fontisto from 'react-native-vector-icons/Fontisto';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Configs from 'utils/Configs';

class SupportView extends Component {
  static defaultProps = {
    isSimple: true
  };

  constructor() {
    super();
    const currentTime = moment().format('HH:mm');
    const appConfigs = Configs.appConfigs || {};
    const hasHotline =
      !!appConfigs.hotline && (Configs.countryCode?.toLowerCase() === 'vn' || Configs.languageCode?.toLowerCase() === 'vi') && currentTime >= '09:00' && currentTime <= '17:00';
    this.state = { hasHotline };
  }

  onPressYoutube = () => {
    const url = Configs.appConfigs?.youtube;
    if (url) Linking.openURL(url).catch((err) => console.log(err));
  };

  onPressMessenger = () => {
    const url = Configs.appConfigs?.messenger || AppConst.FACEBOOK_MESSENGER_URL;
    if (url) Linking.openURL(url).catch((err) => console.log(err));
  };

  onPressPhone = () => {
    const hotline = Configs.appConfigs?.hotline;
    if (hotline) Linking.openURL(`tel:${hotline}`).catch((err) => console.log(err));
  };

  onPressSendEmail = () => {
    const email = Const.app?.devEmail;
    if (email) {
      const url = `mailto:${email}?subject=Feedback ${AppConst.NAME} ${Platform.OS} ${AppConst.VERSION} ${Configs.isFreeVersion ? '' : 'pro'}&body=`;
      Linking.openURL(url).catch((err) => console.log(err));
    }
  };

  renderSupportItem = (icon, color, onPress) => {
    return (
      <BaseButton onPress={onPress} style={styles.supportItem}>
        <View style={[styles.supportIconWrapper, { backgroundColor: color + '15' }]}>{icon}</View>
      </BaseButton>
    );
  };

  renderButtons = () => {
    const appConfigs = Configs.appConfigs || {};
    if (Configs.features?.whatsapp && Configs.isAfricaCountry) {
      return (
        <View style={styles.buttonsContainer}>
          {this.state.hasHotline && this.renderSupportItem(<Fontisto name={'phone'} size={UIConst.SCALE * 18} color={Colors.colorApp} />, Colors.colorApp, this.onPressPhone)}
          {this.renderSupportItem(<Fontisto name={'whatsapp'} size={UIConst.SCALE * 18} color={'#25D366'} />, '#25D366', () => {
            let whatsapp = Configs.features?.whatsapp;
            if (whatsapp) {
              let url = `whatsapp://send?phone=${whatsapp}`;
              Linking.openURL(url).catch(() => {
                DropAlert.warn('', 'WhatsApp is not installed on this device');
              });
            }
          })}
        </View>
      );
    }

    return (
      <View style={styles.buttonsContainer}>
        {this.state.hasHotline && this.renderSupportItem(<Fontisto name={'phone'} size={UIConst.SCALE * 18} color={Colors.colorApp} />, Colors.colorApp, this.onPressPhone)}
        {this.renderSupportItem(<Fontisto name={'messenger'} size={UIConst.SCALE * 18} color={'#0084FF'} />, '#0084FF', this.onPressMessenger)}
        {!!appConfigs.facebook &&
          this.renderSupportItem(<Fontisto name={'facebook'} size={UIConst.SCALE * 18} color={'#1877F2'} />, '#1877F2', () => {
            if (appConfigs.facebook) Linking.openURL(appConfigs.facebook).catch((err) => console.log(err));
          })}
        {!!appConfigs.group &&
          this.renderSupportItem(<FontAwesome name={'group'} size={UIConst.SCALE * 18} color={'#4267B2'} />, '#4267B2', () => {
            const url = appConfigs.group || appConfigs.facebook;
            if (url) Linking.openURL(url).catch((err) => console.log(err));
          })}
        {!!appConfigs.tiktok &&
          this.renderSupportItem(
            <Image source={Images.tiktok} style={{ width: UIConst.SCALE * 18, height: UIConst.SCALE * 18 }} resizeMode={'contain'} tintColor={Colors.text} />,
            '#000000',
            () => {
              if (appConfigs.tiktok) Linking.openURL(appConfigs.tiktok).catch((err) => console.log(err));
            }
          )}
        {!!appConfigs.youtube && this.renderSupportItem(<AntDesign name={'youtube'} size={UIConst.SCALE * 18} color={'#FF0000'} />, '#FF0000', this.onPressYoutube)}
      </View>
    );
  };

  render() {
    if (Configs.user?.id > 0 && AppConst.NOT_SUPPORT_USER_IDS?.indexOf(Configs.user?.id) >= 0) return null;

    if (this.props.isSimple) {
      return (
        <View style={[styles.simpleContainer, this.props.style]}>
          <BaseText style={styles.simpleTitle}>{Lang.menu?.support}</BaseText>
          {this.renderButtons()}
        </View>
      );
    }

    return (
      <View style={[styles.cardContainer, this.props.style]}>
        <View style={styles.headerRow}>
          <View style={styles.iconWrapper}>
            <MaterialCommunityIcons name={'help-circle-outline'} size={UIConst.SCALE * 20} color={'#e67e22'} />
          </View>
          <View style={styles.titleContainer}>
            <BaseText style={styles.titleText}>{Lang.homeScreen?.support}</BaseText>
            <BaseText style={styles.descriptionText}>{Lang.homeScreen?.supportDetail}</BaseText>
            {this.state.hasHotline && (
              <BaseText style={[styles.descriptionText, { marginTop: 2, color: Colors.colorApp, fontWeight: '600' }]}>{Lang.homeScreen?.hotlineSupportDetail}</BaseText>
            )}
          </View>
        </View>

        <View style={styles.footerRow}>{this.renderButtons()}</View>
      </View>
    );
  }
}

export default SupportView;

const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: Colors.box,
    marginTop: UIConst.SCALE * 12,
    padding: UIConst.SCALE * 16,
    borderRadius: UIConst.SCALE * 20,
    borderWidth: 1,
    borderColor: Colors.colorApp + '15',
    shadowColor: Colors.shadow,
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.12,
    shadowRadius: 10,
    elevation: 4
  },
  simpleContainer: {
    marginVertical: UIConst.SCALE * 10,
    justifyContent: 'center',
    alignItems: 'center'
  },
  simpleTitle: {
    marginBottom: UIConst.SCALE * 12,
    fontSize: UIConst.FONT_SIZE - 2,
    fontWeight: '700',
    color: Colors.text1
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  iconWrapper: {
    width: UIConst.SCALE * 40,
    height: UIConst.SCALE * 40,
    borderRadius: UIConst.SCALE * 12,
    backgroundColor: '#e67e2212',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: UIConst.SCALE * 12
  },
  titleContainer: {
    flex: 1
  },
  titleText: {
    fontSize: UIConst.FONT_SIZE,
    fontWeight: '700',
    color: Colors.text,
    marginBottom: UIConst.SCALE * 4
  },
  descriptionText: {
    fontSize: UIConst.FONT_SIZE - 2,
    color: Colors.text1,
    lineHeight: UIConst.SCALE * 18
  },
  footerRow: {
    marginTop: UIConst.SCALE * 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonsContainer: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  supportItem: {
    marginHorizontal: UIConst.SCALE * 4,
    alignItems: 'center',
    justifyContent: 'center'
  },
  supportIconWrapper: {
    width: UIConst.SCALE * 42,
    height: UIConst.SCALE * 42,
    borderRadius: UIConst.SCALE * 12,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.05)'
  },
  supportLabel: {
    marginTop: 4,
    fontSize: UIConst.FONT_SIZE - 8,
    color: Colors.text,
    fontWeight: '600'
  }
});
